export class LongTap {
    private static instance: LongTap|undefined;

    public static getInstance(): LongTap {
        if (!LongTap.instance) {
            LongTap.instance = new LongTap();
        }
        return LongTap.instance;
    }

    private tapTimer: ReturnType<typeof setTimeout>|null = null;

    public longTap = (callback: () => void, duration: number) => {
        if (this.tapTimer) {
            clearTimeout(this.tapTimer);
            this.tapTimer = null;
        }
        this.tapTimer = setTimeout(() => {
            this.tapTimer = null;
            callback?.();
        }, duration);
    };

    public cancelLongTap = () => {
        if (this.tapTimer) {
            clearTimeout(this.tapTimer);
            this.tapTimer = null;
        }
    };
}
